
import { CountUp } from 'countup.js';
import { onMounted, ref } from 'vue';
import log from '@/global/log';

export default {
	components: {},
	setup() {
		// 타이머 아이디를 저장할 변수
		let count1 = ref();
		let count2 = ref();
		let count3 = ref();
		let count4 = ref();
		let docActiveIndex = ref(-1);
		let chanceActiveIndex = ref(-1);
		// 타이머 아이디를 저장할 변수
		let intervalId1;
		let intervalId2;

		const cntObserver1 = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						log('count1.start');
						count1.value.start();
					}
				});
			}
		);
		const cntObserver2 = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						log('count2.start');
						count2.value.start();
					}
				});
			}
		);
		const cntObserver3 = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						log('count3.start');
						count3.value.start();
					}
				});
			}
		);
		const cntObserver4 = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						log('count4.start');
						count4.value.start();
					}
				});
			}
		);
		const img1Timer = () => {
			if (docActiveIndex.value < 3) {
				docActiveIndex.value++;
				log(
					'docActiveIndex : ' +
						docActiveIndex.value
				);
			} else {
				docActiveIndex.value = 0;
			}
		};
		const img2Timer = () => {
			if (chanceActiveIndex.value < 3) {
				chanceActiveIndex.value++;
				log(
					'chanceActiveIndex : ' +
						chanceActiveIndex.value
				);
			} else {
				chanceActiveIndex.value = 0;
			}
		};

		const docCardObserver =
			new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						docActiveIndex.value++;
						intervalId1 = setInterval(() => {
							img1Timer();
						}, 1800);
					} else {
						// div가 화면에서 사라지면 실행할 동작을 여기에 추가합니다.
						clearInterval(intervalId1);
						docActiveIndex.value = 0;
					}
				});
			});

		const chanceCardObserver =
			new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						chanceActiveIndex.value++;
						intervalId2 = setInterval(() => {
							img2Timer();
						}, 1800);
					} else {
						// div가 화면에서 사라지면 실행할 동작을 여기에 추가합니다.
						clearInterval(intervalId2);
						chanceActiveIndex.value = 0;
					}
				});
			});

		const checkOverflow = (elId: string) => {
			const element = document.getElementById(
				elId
			) as HTMLElement;
			if (
				element &&
				element.scrollHeight >
					element.clientHeight
			) {
				return true;
			} else {
				return false;
			}
		};
		const toggleClass = (elId: string) => {
			const element = document.getElementById(
				elId
			) as HTMLElement;
			if (element.classList.contains('active')) {
				element.classList.remove('active'); // active 클래스 제거
			} else {
				element.classList.add('active');
			}
		};

		onMounted(() => {
			count1.value = new CountUp(
				'count1',
				180000,
				{
					enableScrollSpy: true,
					startVal: 100000,
				}
			);
			count2.value = new CountUp(
				'count2',
				100000,
				{
					enableScrollSpy: true,
					startVal: 80000,
				}
			);
			count3.value = new CountUp('count3', 93, {
				enableScrollSpy: true,
			});
			count4.value = new CountUp('count4', 8700, {
				enableScrollSpy: true,
			});

			const cntEl1 = document.getElementById(
				'count1'
			) as HTMLElement;
			const cntEl2 = document.getElementById(
				'count2'
			) as HTMLElement;
			const cntEl3 = document.getElementById(
				'count3'
			) as HTMLElement;
			const cntEl4 = document.getElementById(
				'count4'
			) as HTMLElement;

			const docCardEl = document.getElementById(
				'card1'
			) as HTMLElement;

			const chanceCardEl =
				document.getElementById(
					'card2'
				) as HTMLElement;

			if (docCardEl && chanceCardEl) {
				docCardObserver.observe(docCardEl);
				chanceCardObserver.observe(chanceCardEl);
			}

			if (cntEl1 && cntEl2 && cntEl3 && cntEl4) {
				cntObserver1.observe(cntEl1);
				cntObserver2.observe(cntEl2);
				cntObserver3.observe(cntEl3);
				cntObserver4.observe(cntEl4);
			}
		});
		return {
			docCntVal: [
				{
					title:
						'모바일 APP <br class="pbr"/>이용자 수',
					unit: ['전체', '명'],
				},
				{
					title:
						'APP 접속 <br class="pbr"/>사용자 수',
					unit: ['매일', '명'],
				},
				{
					title:
						'스마트워치 착용 <br class="pbr"/>사용자 비율',
					unit: ['1주 3일이상', '%'],
				},
				{
					title:
						'2023. 07 기준 <br class="pbr"/>전체 사용자 보행수',
					unit: ['하루 평균', '걸음'],
				},
			],
			docActiveIndex,
			chanceActiveIndex,
			docImg: [
				require('@/assets/images/health_business/doc_phone1.png'),
				require('@/assets/images/health_business/doc_phone2.png'),
				require('@/assets/images/health_business/doc_phone3.png'),
				require('@/assets/images/health_business/doc_phone4.png'),
			],
			chanceImg: [
				require('@/assets/images/health_business/chance_phone1.png'),
				require('@/assets/images/health_business/chance_phone2.png'),
				require('@/assets/images/health_business/chance_phone3.png'),
				require('@/assets/images/health_business/chance_phone4.png'),
			],
			checkOverflow,
			toggleClass,
			together: [
				{
					icon: require('@/assets/images/health_business/together1.png'),
					title: '병원',
					arr: [
						'신광한의원',
						'서울대병원 정신과',
						'부산대학교병원',
						'서울대학교 병원 정보화실',
						'세브란스병원',
						'중대광명병원',
					],
					show: null,
				},
				{
					icon: require('@/assets/images/health_business/together2.png'),
					title: '보건소',
					arr: [
						'강릉시 보건소',
						'군포시 보건소',
						'대구 북구보건소 강북보건지소',
						'보은군 보건소',
						'평택보건소 안중보건지소',
						'충북 음성군 보건소',
						'사직동 주민센터',
						'남원시 보건소',
						'금산군 보건소',
						'서귀포 보건소',
						'경기도 광주시 보건소',
						'울산시 북구보건소',
						'춘천시 보건소',
						'서귀포시 서부보건소(S076)',
						'송파구 보건소',
						'충주시 보건소',
					],
					show: null,
				},
				{
					icon: require('@/assets/images/health_business/together3.png'),
					title: '치매센터',
					arr: [
						'성북구 치매안심센터',
						'영등포구 치매안심센터',
						'중랑구 치매안심센터',
						'강남구 치매안심센터',
						'도봉구 치매안심센터',
						'동대문구 치매안심센터',
						'관악구 치매안심센터',
						'강동구 치매안심센터',
						'서초구 치매안심센터',
						'종로구 치매안심센터',
					],
					show: null,
				},
				{
					icon: require('@/assets/images/health_business/together4.png'),
					title: '연구기관',
					arr: [
						'아이캔 프로젝트 연구팀',
						'목포대학교',
						'광주북구청(S077)',
						'한양대학교 서울병원',
						'노원을지대병원',
						'한림대학교 (성심병원)',
					],
					show: null,
				},
				{
					icon: require('@/assets/images/health_business/together5.png'),
					title: '업체',
					arr: [
						'다이아텍코리아',
						'세븐일렉',
						'갓스포',
						'K컴퍼니',
					],
					show: null,
				},
				{
					icon: require('@/assets/images/health_business/together6.png'),
					title: '직장',
					arr: [
						'한국건강관리협회',
						'한국건강관리협회(서부)',
						'한국건강관리협회(동부)',
						'한국건강관리협회(강남)',
						'한국건강관리협회(부산)',
						'한국건강관리협회(대구)',
						'한국건강관리협회(인천)',
						'한국건강관리협회(울산)',
						'한국건강관리협회(경기)',
						'한국건강관리협회(강원)',
						'한국건강관리협회(충북)',
						'한국건강관리협회(충남)',
						'한국건강관리협회(전북)',
						'한국건강관리협회(전남)',
						'한국건강관리협회(경북)',
						'한국건강관리협회(경남)',
						'한국건강관리협회(제주)',
					],
					show: null,
				},
			],
			research: [
				{
					icon: require('@/assets/images/health_business/with_ic1.png'),
					name: '목포대학교',
					period: '2021. 06~2023. 02',
					tool: '헬스앤유플랫폼(APP/WEB), 스마트밴드(HL3)',
					title:
						'IoT 연동 디지털 플랫폼 및 PGHR을 활용한 지역약국 기반 당뇨병 관리 약료 서비스 모델 개발 및 제 2형 당뇨병 위험인자 중재 효과 평가',
					center: '한국연구재단',
				},
				{
					icon: require('@/assets/images/health_business/with_ic2.png'),
					name: '한양대학교 산학협력단',
					period: '2022. 04~2024. 12',
					tool: '헬스앤유플랫폼(APP/WEB), 스마트밴드(HL5)',
					title:
						'심혈관질환 극복을 위한 비알콜성 지방간질환 예방·관리·중재·치료 이행제고 전략개발 (비알코올 지방간 환자에서 모바일 기술을 활용한 시간제한 식사법 중재의 효과 : 무작위 대조군 연구)',
					center:
						'질병관리청, 한국보건사업진흥원',
				},
				{
					icon: require('@/assets/images/health_business/with_ic3.png'),
					name: '한림대학교 산학협력단',
					period: '2022. 09~2024. 02',
					tool: '헬스앤유플랫폼(APP/WEB), 스마트밴드(HL5)',
					title:
						'COVID-19 과거력이 있는 노인에서 activity monitor를 활용한 맞춤형 운동 중재가 낙상에 대한 두려움 및 신체기능에 미치는 효과',
					center: '한국연구재단',
				},
			],
		};
	},
};
